import clsx from 'clsx';
import Image from 'next/image';

import { ITextMediaBlock } from '../../types';

export const TextMediaBlock = (props: ITextMediaBlock) => {
	return (
		<div className="space-y-12 xl:space-y-20">
			{props.items.map((item, key) => {
				const className = clsx(
					'flex flex-col items-center gap-8 xl:gap-10 2xl:gap-12',
					{
						'md:flex-row': item.position === 'left',
						'md:flex-row-reverse': item.position === 'right',
					},
				);
				return (
					<div key={key} className={className}>
						<div className="relative aspect-video w-full shrink-0 overflow-hidden rounded-xl border-gray-3 bg-gray-4 md:w-3/5 xl:w-full xl:max-w-3xl 2xl:max-w-4xl">
							{item.image && (
								<Image
									src={item.image}
									alt={item.title}
									width={900}
									height={520}
									className="absolute left-0 top-0 h-full w-full object-cover"
								/>
							)}
							{item.video && (
								<iframe
									className="absolute left-0 top-0 h-full w-full object-cover"
									src={item.video}
									allow="autoplay; loop; fullscreen; picture-in-picture; encrypted-media; gyroscope; accelerometer; clipboard-write;"
								/>
							)}
						</div>
						<div className="mx-auto flex max-w-3xl flex-col gap-3">
							<p className="text-base/[1.6] font-semibold text-[#090E1C] xl:text-[32px]/[1.6]">
								{item.title}
							</p>
							<p className="text-base/[1.6] font-semibold text-[#4B5675] xl:text-2xl/[1.6]">
								{item.text}
							</p>
						</div>
					</div>
				);
			})}
		</div>
	);
};
